export class CostCentreBriefDto {
  id: number;
  name: string;
  address: string;
}
